export default __webpack_public_path__ + "static/media/Brigand's Gloves of the Howling Wind.feed8646.jpg";